module.exports = __webpack_public_path__ + "static/media/center-bottom.65cb5ce9.png";